import React from "react";
import { connect } from "react-redux";
import { setAlertWarning, clearAlerts } from "../../../store/WriteClass";
import { useEffect } from "react";
import qs from "qs";

const AdminAuth = ({ setAlertWarning, clearAlerts }) => {
  useEffect(function() {
    const queryString = window.location.search.substring(1);
    const queryObject = qs.parse(queryString);
    if (
      queryObject.hasOwnProperty("failure") &&
      queryObject.failure === "true"
    ) {
      setAlertWarning({
        message: "Login failed",
        onDismiss: () => {
          clearAlerts();
        },
        timeout: 3000
      });
    }
  }, []);

  return (
    <div className="adminAuth">
      <h1>Admin login</h1>
      <form
        method="post"
        action={process.env.REACT_APP_API_URL + "/auth/admin"}
      >
        <div className="form-group">
          <label htmlFor="email_input">Email:</label>
          <input
            id="email_input"
            className="form-control"
            type="email"
            name="admin_email"
          />
        </div>
        <div className="form-group">
          <label htmlFor="password_input">Password:</label>
          <input
            id="password_input"
            className="form-control"
            type="password"
            name="admin_password"
          />
        </div>
        <button type="submit" className="btn btn-info">
          Click to Continue
        </button>
      </form>
    </div>
  );
};

export default connect(null, dispatch => {
  return {
    setAlertWarning: alert => dispatch(setAlertWarning(alert)),
    clearAlerts: () => dispatch(clearAlerts())
  };
})(AdminAuth);



// WEBPACK FOOTER //
// ./src/components/admin/auth/index.jsx